import React , {useRef} from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { BlogData } from "../data";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, SplitText);
const BlogOne = () => {
  const container = useRef();
  useGSAP(
    () => {

      // let split = SplitText.create(".content_para_animation", {
      //   type: "words,chars,lines",
      // });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
          // markers: true
        },
      });
      
       tl.fromTo(
          ".blogs_heading_animation",
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0"
        ).fromTo(
          ".blogs_card_animation",
          { opacity: 0, y: 100 },
          {
            opacity: 1,
            y: 0,
            duration: 0.9,
            stagger: 0.2,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
  // let settings = {
  //   dots: false,
  //   arrows: false,
  //   infinite: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   speed: 500,
  //   autoplaySpeed: 5000,
  //   cssEase: "linear",

  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: { slidesToShow: 3 },
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 3,
  //         arrows: false,
  //       },
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1,
  //         arrows: false,
  //       },
  //     },
  //   ],
  // };
  return (
    <>
      <section className="blog-area-1 space " ref={container}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div className="title-area text-center">
                <span className="sub-title blogs_heading_animation">
                  <img src="/assets/img/icon/title_left.svg" alt="shape" />
                  Latest Blog
                </span>
                <h2 className="sec-title blogs_heading_animation">
              Strategic Solutions for
Business Growth
                </h2>
              </div>
            </div>
          </div>
          <div className="row ">
              {BlogData.map((item,index)=>{
                return(

                  <div className="blog-card p-3 col-4 blogs_card_animation" key={index}>
                <div className="blog-img">
                  <img src={item.img} alt="blogcard" />
                </div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <Link to={item.btnLink}>
                      <i className="fas fa-user" />
                      By admin
                    </Link>
                    <Link to="/blog">
                      <i className="fas fa-comments" />
                      Comments
                    </Link>
                  </div>
                  <h3 className="blog-title">
                    <Link to={item.btnLink}>
                    {item.title}
                    </Link>
                  </h3>
                </div>
              </div>
                )
              })}
              
 
          </div>
        </div>
      </section>
      {/* <div className="container">
        <div className="footer-top-1 bg-theme">
          <div className="footer-top-content">
            <h3 className="footer-top-title text-white">Newsletter</h3>
            <p className="footer-top-text">
              Lorem Ipsum is simply dummy text of the printing
            </p>
          </div>
          <form className="newsletter-form">
            <div className="form-group">
              <input
                className="form-control"
                type="email"
                placeholder="Email Address"
                required=""
              />
              <button type="submit" className="global-btn">
                Subscribe
                <span className="icon">
                  <i className="fa-sharp fas fa-paper-plane ms-2" />
                </span>
              </button>
            </div>
          </form>
        </div>
      </div> */}
    </>
  );
};

export default BlogOne;
